import { Component, OnInit } from '@angular/core';
import { AddProductComponent } from '../add-product/add-product.component';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';

import { ProductService, ToasterService } from '../../_services/';

import { NgxSpinnerService } from "ngx-spinner";
import { EditProductComponent } from '../edit-product/edit-product.component';

import * as firebase from 'firebase/app'; // Typescript
import { environment } from '../../../environments/environment';


@Component({
  selector: 'app-product-list',
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.scss']
})
export class ProductListComponent implements OnInit {
  public productList:any[];
  constructor(
    private dialog : MatDialog,
    private spinner: NgxSpinnerService,
    private _product : ProductService,
    private _toaster: ToasterService
  ) { }

  ngOnInit(): void {
    if(firebase.apps.length < 2){
      const app= firebase.initializeApp(environment.firebaseConfig);
      if(window.location.host.includes('localhost')){
        app.functions().useFunctionsEmulator('http://localhost:5001');
      }
    }
    this.getProductList()
  }


  getProductList(){
    this.spinner.show();
    this._product.getProductList().subscribe(result=>{
      this.productList = result;
      this.spinner.hide();
    },err=>{
      this._toaster.showError("Something went wrong", "Error"); 
    })
  }

  addProduct(){
    this.dialog.open(AddProductComponent, {
      width: 'auto',
    });
  }
  editProduct(id){
    this.dialog.open(EditProductComponent, {
      width: 'auto',
      data:{
        id : id
      }
    });
  }

  deleteProduct(id){
    this.spinner.show();
    // Delete product images...
    const storageRef = firebase.storage().ref();
    this._product.getProductDetailById(id).subscribe(product=>{
      const pictures = product.length>0 && product[0].payload.doc.data().pictures ? product[0].payload.doc.data().pictures : [];
      pictures.forEach(element => {
        if(element.path){
          // Create a reference to the file to delete
          const desertRef = storageRef.child(element.path);
          // Delete the file
          desertRef.delete().then(() => {
            // File deleted successfully
          }).catch((error) => {
            this._toaster.showError("Error occured while deleting product images", "Error");    
          });
        }
        
      });
      this._product.deleteProduct(id).then(result=>{
        this.spinner.hide();
        this._toaster.showSuccess("Product deleted successfully!", "Success");
      }).catch(err=>{
        this._toaster.showError("Something went wrong", "Error");
      })
    },err=>{
      this._toaster.showError("Something went wrong", "Error");    
    })

  }

}
